module.exports = __webpack_public_path__ + "880bc76e8e1457177bf56bd9492334ae.pdf";